import { useTranslation } from 'react-i18next';
import Button from '@/components/base/Button';

export default function HeroSection() {
  const { t } = useTranslation();

  return (
    <section className="relative w-full min-h-[520px] md:min-h-[600px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Soft%20minimal%20workspace%20with%20laptop%20on%20warm%20cream%20desk%2C%20shopping%20concept%20with%20parcel%20boxes%20and%20coffee%2C%20gentle%20natural%20lighting%20from%20window%2C%20clean%20aesthetic%20interior%2C%20beige%20and%20cream%20tones%2C%20modern%20European%20editorial%20style%2C%20soft%20shadows%2C%20peaceful%20atmosphere%2C%20high%20quality%20photography&width=1600&height=900&seq=hero-main-2026&orientation=landscape"
        alt="Kakobuy Spreadsheet Polska"
        className="absolute inset-0 w-full h-full object-cover object-center"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/25 via-black/18 to-black/25"></div>
      
      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 py-16 md:py-24 text-center">
        <h1 className="text-2xl md:text-4xl lg:text-5xl font-heading font-bold text-white mb-4 md:mb-6 leading-tight">
          {t('hero.h1')}
        </h1>
        <p className="text-sm md:text-base text-white/85 max-w-2xl mx-auto mb-8 md:mb-10 leading-relaxed">
          {t('hero.subtitle')}
        </p>
        
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3 md:gap-4 mb-8 md:mb-10">
          <Button variant="primary" href="https://kaspreadsheet.com" className="px-8 py-3.5 text-base md:text-lg">
            {t('hero.primaryCta')}
          </Button>
          <Button variant="secondary" href="https://kaspreadsheet.com" className="px-8 py-3.5 text-base md:text-lg">
            {t('hero.secondaryCta')}
          </Button>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-3 md:gap-4">
          <span className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-white/15 backdrop-blur-sm rounded-full text-xs md:text-sm text-white">
            <i className="ri-check-line text-accent-400"></i> {t('hero.badge1')}
          </span>
          <span className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-white/15 backdrop-blur-sm rounded-full text-xs md:text-sm text-white">
            <i className="ri-check-line text-accent-400"></i> {t('hero.badge2')}
          </span>
          <span className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-white/15 backdrop-blur-sm rounded-full text-xs md:text-sm text-white">
            <i className="ri-check-line text-accent-400"></i> {t('hero.badge3')}
          </span>
          <span className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-white/15 backdrop-blur-sm rounded-full text-xs md:text-sm text-white">
            <i className="ri-check-line text-accent-400"></i> {t('hero.badge4')}
          </span>
        </div>
      </div>
    </section>
  );
}